/** Stacked fields (profile, org defaults, settings dialogs) for a consistent narrow form band. */
export const SETTINGS_FORM_STACK_CLASS = "w-full max-w-xl";

/** Dashboard DataTable-aligned surface for settings list tables. */
export const SETTINGS_TABLE_WRAPPER = "overflow-hidden rounded-lg border border-[#eeeff1] bg-white";

/** Toolbar strip above embedded `DataTable` (search + rows-per-page + actions). */
export const SETTINGS_TABLE_TOOLBAR_CLASS = "border-b border-[#eeeff1] bg-stone-50/90 px-4 py-2.5";
